import React, { Component } from "react";
import { toast } from "react-toastify";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import { Modal, Form, Button, OverlayTrigger, Tooltip, Row } from "react-bootstrap";

import axios from "../../axios";
import apiError from "../../error";
import Spinner from "../spinner/spinner";

import "./rightside-modal.css";
import swal from "sweetalert";
import swalAlert from "../../swalFunction";
import { getCookie } from "../../function";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import Loader from "../loader/loader";

export default class RightSideModalSendReportToEmails extends Component {
    state = {
        loading: false,
        enteredEmails: [],
    }

    validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    handleAddRecipientEmails = (newValue) => {
        if (newValue.length > this.state.enteredEmails.length) {
            let addedEmail = newValue[newValue.length - 1].label;
            if (this.validateEmail(addedEmail)) {
                this.setState({ enteredEmails: newValue });
            } else {
                toast.error("Please enter a valid email address");
            }
        } else {
            this.setState({ enteredEmails: newValue });
        }
    }

    resetStates = () => {
        this.setState({
            enteredEmails: [],
            loading: false
        });
    }

    handleClose = () => {
        this.resetStates();
        this.props.handleModal(false);
    }

    handleReportSendToEmails = () => {
        const { enteredEmails } = this.state;
        if (enteredEmails.length > 0) {
            this.props.sendReportToEmails(enteredEmails.map(email => email.value));
        }
    }

    render() {

        return (
            <>
                <Modal className="info-filter right mainfooterModal right-modal-wrap" show={this.props.show} onHide={this.handleClose} autoFocus keyboard>
                    <Modal.Header closeButton>
                        <div>
                            <h5>Send Reports</h5>
                            <p>Share the report with selected recipients</p>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="addUserDetail">
                            <Row>
                                <div className="col-md-12 mb-4">
                                    <label className="form-label">Recipients</label>
                                    <CreatableSelect
                                        isMulti
                                        isClearable
                                        value={this.state.enteredEmails}
                                        onChange={this.handleAddRecipientEmails}
                                        placeholder="Type recipient email and press enter"
                                        components={{
                                            DropdownIndicator: () => null,
                                            Menu: () => null,
                                        }}
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                borderColor: "#ced4da",
                                                boxShadow: "none",
                                                "&:hover": {
                                                    borderColor: "#ced4da",
                                                },
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: "0.875rem",
                                                color: "#6c757d",
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: "#e2e3e4",
                                            }),
                                            multiValueLabel: (base) => ({
                                                ...base,
                                                color: "#212529",
                                            }),
                                            multiValueRemove: (base) => ({
                                                ...base,
                                                color: "#000",
                                                cursor: "pointer",
                                                ":hover": {
                                                    backgroundColor: "#999",
                                                    color: "#fff",
                                                },
                                            }),
                                        }}
                                    />
                                </div>

                            </Row>


                        </div>

                    </Modal.Body>
                    <div className="modalFooter">
                        <div className="row ">
                            <div className="col-md-12 text-right">
                                <button type="button" className="btn closeBtn" onClick={this.handleClose}>Cancel</button>
                                <Button
                                    className={` btn btn-success ml-2`}
                                    onClick={this.handleReportSendToEmails}
                                    disabled={this.state.enteredEmails.length === 0}
                                >
                                    <Spinner loading={this.state.loading}></Spinner>
                                    Send
                                </Button>
                            </div>
                        </div>
                    </div>
                </Modal>
                {this.props.isReportGenerating && <Loader />}
            </>
        );
    }
}
